import { LayoutProviderView } from '@euler/components/layout/LayoutProvider';
import { memo } from 'react';
import { BasicInfoSection } from './BasicInfoSection';
import { CustomerInfoSection } from './CustomerInfoSection';
import { CustomerSignSection } from './CustomerSignSection';
import { DashboardInfoSection } from './DashboardInfoSection';
import { ServiceSubjectSection } from './ServiceSubjectSection';
import { TermsOfServiceSection } from './TermsOfServiceSection';

export const OrderDetailContent = memo(
  ({
    hideDashboardInfo,
    hideSignInfo,
    hideBasicInfoTitle,
    ...props
  }: {
    hideDashboardInfo?: boolean;
    hideSignInfo?: boolean;
    hideBasicInfoTitle?: boolean;
    hideEstimatedFinishTime?: boolean;
    hideVIN?: boolean;
    hideMileage?: boolean;
    hideTags?: boolean;
    hideRemark?: boolean;
    hideServiceAgent?: boolean;
    hideQrcode?: boolean;
  }) => {
    return (
      <LayoutProviderView>
        <BasicInfoSection hideTitle={hideBasicInfoTitle} {...props} />
        <ServiceSubjectSection />
        <CustomerInfoSection />
        {!hideDashboardInfo && <DashboardInfoSection />}
        <TermsOfServiceSection />
        {!hideSignInfo && <CustomerSignSection />}
      </LayoutProviderView>
    );
  },
);
